import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { clientContactsService } from '../api/client-contacts.service';
import { CLIENT_CONTACTS_KEYS } from './queryKeys';

export const useDeleteClientContact = (clientId: string) => {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: (contactId: string) => clientContactsService.delete(clientId, contactId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CLIENT_CONTACTS_KEYS.byClient(orgId, clientId) });
    },
  });
};
